import { TApplicationState } from '../../types/redux';

export function getIsFloorPlanAvailable(state: TApplicationState) {
  return state.newbuilding.isFloorPlanAvailable;
}
